export default __webpack_public_path__ + "media/images/invalid-icon-grey-6206afd3.svg";